const Config = {
  money: {
    maximumFractionDigits: 0,
    fallbackCurrency: 'RUB'
  },
  localeWrapper: {
    fallbackLocale: 'ru'
  }
};
const setConfig = config => {
  return Object.assign(Config, config);
};
const getConfig = () => {
  return Config;
};

export { Config as default, getConfig, setConfig };
